import React from "react";
import "../../scss/Footer.css";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="footer">
      <div className="footer-left"></div>
      <div className="footer-center">
        <p>&copy; Copyright {new Date().getFullYear()}. All Rights Reserved.</p>
      </div>

      <div className="footer-right">
        <p
          className="text-primary"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/contact-us");
          }}
        >
          Having an issue?
        </p>
      </div>
    </footer>
  );
};

export default Footer;
